import angular from 'angular';

import r2a from '@web/angularIntegration/r2a';
import TimesheetViewModalAngular from '@web/timesheets/TimesheetViewModal/TimesheetViewModalAngular';
import TimesheetHistoryReact from '@web/timeClock/TimesheetHistory/TimesheetHistoryAngular';
import CreateTimesheetAngular from '@web/timesheets/CreateTimesheet/CreateTimesheetAngular';
import EditTimesheetModalAngular from '@web/timesheets/EditTimesheetModal/EditTimesheetModalAngular';
import EmployeePendingConsentTimesheetViewModalAngular from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/EmployeePendingConsentTimesheetViewModalAngular';
import TimesheetStatusLabelAngular from '@web/timesheets/TimesheetStatusLabel/TimesheetStatusLabelAngular';

import { accessLevels } from '../constants';
import managePreviewRedirects from '../account/managePreviewRedirects';
import { rTimesheetErrorTip } from '../../react/integrations/TimesheetErrorTipAngular';

import TimesheetsCtrl from './TimesheetsCtrl';
import timesheetsTableComponent from './components/timesheetsTableComponent';
import editTimesheetsComponent from './components/editTimesheetsComponent';
import editTimesheetGroupComponent from './components/editTimesheetGroupComponent';
import timeclockPreviewComponent from './components/timeclockPreviewComponent';
import timesheetsSubNavComponent from './components/timesheetsSubNavComponent';
import timeFieldComponent from './components/timeFieldComponent';
import TimesheetsServiceImport from './services/TimesheetsService';
import TimesheetsUtilsImport from './services/TimesheetsUtilsService';
import indexUrl from './index.html';
import timesheetsUrl from './timesheets.html';
import noAccessUrl from './no-access.html';
import timesheetsReportColumn from './directives/timesheetsReportColumn';
import viewTimesheetModalComponent from './components/viewTimesheetModalComponent';
import viewTimesheetGroupComponent from './components/viewTimesheetGroupComponent';
import noteHistoryLogComponent from './components/noteHistoryLogComponent';
import timeclockMapPopupComponent from './components/timeclockMapPopupComponent';
import timeclockLocationComponent from './components/timeclockLocationComponent';

const timeclockModule = angular.module('sling.timeclock', []);
timeclockModule.config(($stateProvider) => {
  $stateProvider.state('timeclock', {
    templateUrl: indexUrl,
    controllerAs: 'ctrl',
    url: '/timeclock',
    data: {
      title: 'Timeclock',
    },
    resolve: {
      personaCollection(PersonaCollection) {
        return PersonaCollection.loadData();
      },
      shiftUtils(ShiftUtils) {
        return ShiftUtils.loadAsync();
      },
    },
    onEnter(Authentication, $state) {
      'ngInject';

      if (
        !Authentication.user.org.isPremium ||
        (Authentication.user.orgSettings.clockInEnabled && Authentication.user.timeclockEnabled) ||
        Authentication.user.isManager
      ) {
        return;
      }

      $state.go('dashboard.home');
    },
  });

  $stateProvider.state('timeclock.timesheets', {
    templateUrl: timesheetsUrl,
    controller: 'TimesheetsCtrl',
    controllerAs: 'ctrl',
    reloadOnSearch: false,
    url: '/timesheets?date',
    data: {
      title: 'Timesheets',
    },
    onEnter(TimesheetsService, RateService) {
      'ngInject';

      TimesheetsService.joinSocketRoom();
      RateService.triggerRateModal();
    },
    onLeave(TimesheetsService) {
      'ngInject';

      TimesheetsService.leaveSocketRoom();
    },
  });

  $stateProvider.state('timeclock.preview', {
    url: '/preview',
    data: {
      title: 'Preview',
      access: accessLevels.manager,
    },
    template: `
      <timeclock-preview></timeclock-preview>
    `,
  });

  $stateProvider.state('timeclock.no-access', {
    url: '/no-access',
    templateUrl: noAccessUrl,
    data: {
      title: 'No access',
    },
  });
});

timeclockModule.run(($transitions, Authentication) => {
  $transitions.onStart(
    {
      to: 'timeclock.**',
    },
    (transition) => {
      if (!Authentication.user.clientcache.reports) {
        Authentication.user.clientcache.reports = {};
      }

      return managePreviewRedirects(
        Authentication,
        transition,
        'clockIn',
        'timeclock',
        'timeclock.timesheets',
        'timeclock.no-access'
      );
    }
  );
});

timeclockModule.controller('TimesheetsCtrl', TimesheetsCtrl);
timeclockModule.service('TimesheetsService', TimesheetsServiceImport);
timeclockModule.service('TimesheetsUtils', TimesheetsUtilsImport);
timeclockModule.directive('timesheetsReportColumn', timesheetsReportColumn);
timeclockModule.component('timesheetsTable', timesheetsTableComponent);
timeclockModule.component('editTimesheets', editTimesheetsComponent);
timeclockModule.component('editTimesheetGroup', editTimesheetGroupComponent);
timeclockModule.component('timesheetsSubNav', timesheetsSubNavComponent);
timeclockModule.component('timeField', timeFieldComponent);
timeclockModule.component('timeclockPreview', timeclockPreviewComponent);
timeclockModule.component('viewTimesheetModal', viewTimesheetModalComponent);
timeclockModule.component('viewTimesheetGroup', viewTimesheetGroupComponent);
timeclockModule.component('noteHistoryLog', noteHistoryLogComponent);
timeclockModule.component('timeclockMapPopup', timeclockMapPopupComponent);
timeclockModule.component('timeclockLocation', timeclockLocationComponent);
timeclockModule.component('rTimesheetHistory', r2a(TimesheetHistoryReact));
timeclockModule.component('rTimesheetViewModal', r2a(TimesheetViewModalAngular));
timeclockModule.component('rCreateTimesheet', r2a(CreateTimesheetAngular));
timeclockModule.component('rEditTimesheetModal', r2a(EditTimesheetModalAngular));
timeclockModule.component(
  'rEmployeePendingConsentTimesheetViewModal',
  r2a(EmployeePendingConsentTimesheetViewModalAngular)
);
timeclockModule.component('rTimesheetStatusLabel', r2a(TimesheetStatusLabelAngular));
timeclockModule.component('rTimesheetErrorTip', rTimesheetErrorTip);

export default timeclockModule.name;
